import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import InsightAPI from '@src/api/InsightsApi';
import moment from 'moment';
import InsightsSidePanel from './InsightsSidePanel';
import Breakpoint from '../../utils/breakpoints';

import { NitroGridStyled } from '../fbt/driver/components/nitro-components.styled';

import NitroCard from '../fbt/driver/components/NitroCard';
import LoadMoreTile from './components/fbtdriver/loadmoretile';

import {
  NitroDataGrid,
  NitroPanel,
  NitroNavBar,
  NitroSingleSelect,
  NitroLoading,
  NitroGrids,
} from 'nitro-components';

import {
  DateFormatter,
  GriddleAction,
} from '../../components/utils/TableUtils';

import * as routes from '../../routes/const';
import {
  ControllersContainer,
  GridContainer,
  ReportingPeriods,
  FilterTabs,
  Tab,
  FilterGroupHeader,
  ContainerTop,
  ExportDiv,
  ExportFBTDiv,
  ExportDivContainer,
  ExportDivEmpty,
  ViewBySpan,
} from './styled';
import { NitroText } from 'nitro-components/build/nitro';

const TABLE_ROW_LIMIT = 15;

const ADDITIONAL_COLUMN = {
  columnName: 'MoreDetails',
  displayName: '  ',
  sortable: false,
  customComponent: () => <GriddleAction content="Details" />,
};

const columnMetaData = [
  {
    columnName: 'leaseId',
    displayName: 'Lease Id',
  },
  {
    columnName: 'firstName',
    displayName: 'Name',
    customComponent: ({ data, rowData }) => (
      <span>
        {rowData.firstName} {rowData.lastName}
      </span>
    ),
  },
  {
    columnName: 'email',
    displayName: 'Email',
  },
  {
    columnName: 'registrationNumber',
    displayName: 'Registration Number',
  },
  {
    columnName: 'make',
    displayName: 'Make',
  },
  {
    columnName: 'allocationStartDate',
    displayName: 'Allocation Start Date',
    customComponent: DateFormatter,
  },
  {
    columnName: 'allocationEndDate',
    displayName: 'Allocation End Date',
    customComponent: DateFormatter,
  },
  {
    columnName: 'exemptionDays',
    displayName: 'Total Exemption Days',
  },
  {
    columnName: 'totalContributions',
    displayName: 'Total Contributions',
  },
];

class TableDetails extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      currentPage: 0,
      tableDataUrl: '',
      csvDataUrl: '',
      tableData: [],
      displayData: [],
      displayProperties: [],
      displayChild: false,
      selectedChild: '',
      key: '',
      reportTitle: '',
      filters: [],
      selectedTabIndex: 0,
      display: 'Table',
      contentAPI: '/contents?id=:id',
      columnMeta: [],
      isFetchingDrillDownData: false,
      drillDownData: [],
      drillDownUrl: '',
      currentReportingPeriod: { id: 0 },
      reportingPeriods: [],
      selectedReportingPerioidId: 123,
      gridDataUrl: '',
      isLoading: false,
      tilePage: 0,
    };

    this.getSelectedChild = this.getSelectedChild.bind(this);
    // this.onChangeTab = this.onChangeTab.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.getGridData = this.getGridData.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleAddSelectedOptions = this.handleAddSelectedOptions.bind(this);
  }

  componentWillMount() {
    const contentId = this.props.routeParams.id;
    const contentUrl = this.state.contentAPI.replace(':id', contentId);

    this.setState({
      isLoading: true,
    });

    InsightAPI.getGenericInsightData(contentUrl)
      .then(data => {
        const response = data.data[0];
        const gridDataUrl = response.url;

        let reportSettings = JSON.parse(data.data[0].metadata);
        reportSettings = reportSettings.reportSetting;
        let drillDownUrl = reportSettings.drillDownUrl;
        drillDownUrl = drillDownUrl.replace('{{contentId}}', contentId);

        this.setState(
          {
            drillDownUrl,
            filters: reportSettings.filters,
            csvDataUrl: reportSettings.exportDataUrl,
            reportTitle: reportSettings.reportTitle,
            exports: reportSettings.exports,
            columnMeta: columnMetaData,
            gridDataUrl,
            isLoading: true,
          },
          () => {
            if (this.state.filters.length > 0) {
              this.state.filters.map((i, index) => {
                if (i.defaultSelected) {
                  this.setState({ selectedTabIndex: index });
                }
              });
            }
          }
        );

        this.getReportPeriods();
      })
      .catch(err => {
        console.log(err);
      });
  }

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  getReportPeriods = () => {
    const reportId = this.props.location.query.report;

    InsightAPI.getReportPeriods().then(response => {
      const currentReportingPeriod =(response.currentReportingPeriod===null)? ((response.reportingPeriods!==undefined && response.reportingPeriods.length>0)? response.reportingPeriods[0]: null): response.currentReportingPeriod;
      this.setState({
        currentReportingPeriod,
        reportingPeriods: response.reportingPeriods,
      });

      let currentReportId;
      if (reportId) {
        currentReportId = reportId;
      } else {
        currentReportId = currentReportingPeriod
          ? currentReportingPeriod.id + ''
          : '0';
      }

      this.setState({
        selectedReportingPerioidId: currentReportId,
      });

      this.getGridData(currentReportId, 0, '');
    });
  };

  PrepareColumnMetaData = ColumnsMetaData => {
    const columnMetaList = [];
    ColumnsMetaData.map(x => {
      const customComp =
        x.customComponent === 'DateFormatter' ? DateFormatter : null;

      const obj = {
        columnName: x.columnName,
        displayName: x.displayName,
        visible:
          x.visible === undefined ? true : x.visible === 'false' ? false : true,
      };
      if (customComp != null) obj.customComponent = customComp;
      columnMetaList.push(obj);
    });

    return columnMetaList;
  };

  getDrillDownData = url =>
    InsightAPI.getGenericInsightData(url)
      .then(data => {
        if (data) {
          this.setState({
            isFetchingDrillDownData: false,
            drillDownData: data.data.Root.Data,
          });
        }
      })
      .catch(err => err);

  onExportFBTTaxClick = dataUrl => {
    const url = dataUrl.replace(
      '{{reportingPeriodId}}',
      this.state.selectedReportingPerioidId
    );
    InsightAPI.getGenericInsightDataFile(url);
  };

  closeDrillDown = () => {
    this.setState({ isOpen: false });
  };

  getData(properties, data) {
    return properties.map(key => <td>{data[key]}</td>);
  }

  getHeaderNames(objData) {
    const property = Object.getOwnPropertyNames(objData);
    const headerRow = new Array();
    property.forEach(e => {
      if (!(objData[e] instanceof Array)) headerRow.push(e);
    });
    headerRow.push('Details');
    return headerRow;
  }

  goBack() {
    const { router } = this.context;
    router.push(routes.INSIGHTS);
  }

  onChangeTab(item, index) {
    const selectedTab = this.state.filters.filter((item, idx) => {
      if (index === idx) return item;
    });
    this.setState({ selectedTabIndex: index, currentPage: 0 }, () => {
      this.getGridData(
        this.state.selectedReportingPerioidId,
        this.state.currentPage,
        selectedTab[0].value
      );
    });

    // let result=this.prepareData();
  }

  getSelectedChild() {
    return this.state.selectedChild;
  }

  GetTypedData(dataElement) {
    const formats = [moment.ISO_8601, 'MM/DD/YYYY  :)  HH*mm*ss'];
    if (moment(dataElement, formats, true).isValid()) {
      return new Date(dataElement).toLocaleDateString();
    } else if (typeof dataElement === typeof true) {
      return dataElement === true ? 'Yes' : 'No';
    }

    return dataElement;
  }

  onRowClick = rowData => {
    // debugger;
    // let isOpen=this.state.isOpen;
    const data = rowData.props === undefined ? rowData : rowData.props.data;
    let drillDownUrl = this.state.drillDownUrl;
    drillDownUrl = drillDownUrl.replace('{{leaseId}}', data.leaseId);
    drillDownUrl = drillDownUrl.replace('{{driverId}}', data.driverId);
    drillDownUrl = drillDownUrl.replace(
      '{{reportPeriodId}}',
      this.state.selectedReportingPerioidId
    );

    this.setState(
      {
        isOpen: true,
        isFetchingDrillDownData: true,
        drillDownData: [],
      },
      () => {
        this.getDrillDownData(drillDownUrl);
      }
    );
  };

  handleAddSelectedOptions = event => {
    const selectedData = event.value;

    const router = this.context.router;
    const contentId = this.props.routeParams.id;
    const newroute =
      this.context.location.pathname +
      '?report=:report'.replace(':report', selectedData);
    this.context.router.push(newroute);
    this.setState({
      currentReportingPeriod: selectedData,
      tilePage: 0,
    });
    this.getGridData(selectedData, 0, '');
  };

  getGridDataWithSorting = (page, sortQuery) => {
    const reportId = this.state.selectedReportingPerioidId;
    this.getGridData(reportId, page, sortQuery);
  };

  getGridDataInfinite = () => {
    const { selectedReportingPerioidId: reportId, tilePage } = this.state;

    this.setState(
      {
        tilePage: tilePage + 1,
      },
      () => {
        const newTilePage = this.state.tilePage;
        this.getGridData(reportId, newTilePage);
      }
    );
  };

  getGridData(selectedReportingPerioidId, page, sortQuery) {
    const {
      gridDataUrl,
      isLoading,
      gridDataFetching,
      selectedTabIndex,
    } = this.state;

    const filterSelected = this.state.filters.filter(
      (item, index) => index === selectedTabIndex
    );
    filterSelected.length > 0 &&
      (sortQuery =
        sortQuery === '' || sortQuery === undefined
          ? filterSelected[0].value
          : sortQuery);

    const contentId = this.props.routeParams.id;

    this.setState({
      tableData: [],
      total: 0,
      currentPage: 0,
      selectedReportingPerioidId,
      isLoading: true,
    });

    let url = gridDataUrl;
    url = url
      .replace('{{reportPeriodId}}', selectedReportingPerioidId)
      .replace('{{contentId}}', contentId)
      .replace('{{offset}}', parseInt(page * TABLE_ROW_LIMIT))
      .replace('{{limit}}', TABLE_ROW_LIMIT)
      .replace('{{filter}}', sortQuery);

    return InsightAPI.getGenericInsightData(url)
      .then(data => {
        const columnMeta = [...this.state.columnMeta, ADDITIONAL_COLUMN];
        this.setState({
          isLoading: false,
          columnMeta: columnMeta,
          //this.ParseData(
          tableData: data.data === undefined ? data.details : data.data.details,
          //),
          total: data.data === undefined ? data.total : data.data.total,
          currentPage: page,
        });
        //this.ParseData(data.data.Details);
      })
      .catch(err => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  getVehicleNotificationIcon(vehicle) {
    const hasSubmitted = Boolean(vehicle.IsSubmitted);
    if (hasSubmitted) return 'success';
    if (!hasSubmitted) return 'warning';

    return null;
  }

  render() {
    const {
      displayProperties,
      filters,
      reportingPeriods,
      selectedReportingPerioidId,
      columnMeta,
      // gridDataFetching,
      isLoading,
      // isLoading2,
      isFetchingDrillDownData,
      exports,
      tableData,
    } = this.state;

    const headers = (
      <tr>
        {displayProperties.map((name, n) => (
          <th key={n}>{name}</th>
        ))}
      </tr>
    );

    const getSelectOptions = options => {
      const opt = [];
      if (reportingPeriods !== undefined) {
        reportingPeriods.forEach(element => {
          const startDate = moment(element.startDate).format('DD/MM/YYYY');
          const endDate = moment(element.endDate).format('DD/MM/YYYY');
          const label = `${startDate} - ${endDate}`;
          opt.push({ value: element.id + '', label });
        });
      }
      return opt;
    };

    const ExportDIV =
      exports &&
      exports.map((exportItem, idx) => (
        <ExportFBTDiv
          key={`fbt_${idx}`}
          onClick={() => this.onExportFBTTaxClick(exportItem.exportDataUrl)}
        >
          <i className="fas fa-file-download" />
          {exportItem.exportLabel}
        </ExportFBTDiv>
      ));

    return (
      <ContainerTop>
        <NitroNavBar
          label={this.state.reportTitle}
          header
          variant="secondary"
          action={this.goBack}
          style={{ marginBottom: '10px' }}
        />

        <NitroPanel>
          <section>
            {isLoading && (
              <div>
                {/* <DisableCover /> */}
                <NitroLoading center screen />
                {/* <NitroLoading /> */}
              </div>
            )}
            <ControllersContainer>
              <Breakpoint name="desktop">
                <FilterGroupHeader>
                  <FilterTabs>
                    {filters &&
                      filters.map((item, index) => (
                        <Tab
                          key={index}
                          selected={this.state.selectedTabIndex === index}
                          onClick={() => this.onChangeTab(item, index)}
                        >
                          {item.label}
                        </Tab>
                      ))}
                  </FilterTabs>
                </FilterGroupHeader>

                <ReportingPeriods>
                  <NitroSingleSelect
                    alignLeft
                    mandatory
                    placeholder="Reporting Periods"
                    bold
                    options={getSelectOptions()}
                    action={e => this.handleAddSelectedOptions(e)}
                    value={selectedReportingPerioidId}
                  />
                </ReportingPeriods>

                <ExportDivContainer>{ExportDIV}</ExportDivContainer>
              </Breakpoint>

              <Breakpoint name="mobileTablet" style={{ width: '100%' }}>
                <ExportDivContainer>{ExportDIV}</ExportDivContainer>

                <ReportingPeriods>
                  <div style={{ marginBottom: '10px' }}>
                    <NitroText variant="base2" bold>
                      Reporting Periods
                    </NitroText>
                  </div>
                  <NitroSingleSelect
                    alignLeft
                    mandatory
                    placeholder="Reporting Periods"
                    bold
                    options={getSelectOptions()}
                    action={e => this.handleAddSelectedOptions(e)}
                    value={selectedReportingPerioidId}
                  />
                </ReportingPeriods>

                <FilterGroupHeader>
                  <FilterTabs>
                    {filters &&
                      filters.map((item, index) => (
                        <Tab
                          key={index}
                          selected={this.state.selectedTabIndex === index}
                          onClick={() => this.onChangeTab(item, index)}
                        >
                          {item.label}
                        </Tab>
                      ))}
                  </FilterTabs>
                </FilterGroupHeader>
              </Breakpoint>
            </ControllersContainer>

            <Breakpoint name="desktop">
              <GridContainer>
                <NitroDataGrid
                  results={tableData}
                  totalCount={this.state.total}
                  rowPerPage={TABLE_ROW_LIMIT}
                  columnMetaData={columnMetaData}
                  onRowClick={this.onRowClick}
                  fetchExternalData={this.getGridDataWithSorting}
                  currentPage={this.state.currentPage}
                  sortColumnAscendingCls="sort-column-ascending"
                  sortColumnDescendingCls="sort-column-descending"
                />
              </GridContainer>
            </Breakpoint>
          </section>
        </NitroPanel>

        <Breakpoint name="mobileTablet">
          <NitroGrids>
            {tableData &&
              tableData.map((vehicle, idx) => {
                return (
                  <NitroGridStyled grid={4} key={'grid_' + idx}>
                    <NitroPanel noMargin>
                      <NitroCard
                        primaryText={`${vehicle.make}`}
                        secondaryText={vehicle.registrationNumber}
                        exemptionsCount={vehicle.exemptionsCount}
                        exemptionsLength={vehicle.exemptionDays}
                        contributionsCount={0}
                        contributionsTotal={vehicle.totalContributions}
                        action={() => this.onRowClick(vehicle)}
                        notificationIcon={this.getVehicleNotificationIcon(
                          vehicle
                        )}
                        notificationIconVariant={
                          this.getVehicleNotificationIcon(vehicle) === 'success'
                            ? 'green'
                            : 'warning'
                        }
                      />
                    </NitroPanel>
                  </NitroGridStyled>
                );
              })}
          </NitroGrids>
        </Breakpoint>

        <InsightsSidePanel
          fetchingGraphDetail={isFetchingDrillDownData}
          tableData={this.state.drillDownData}
          actions={this.state.drillDownSelected}
          // companyCode={this.props.costcenter}
          // country={this.props.country}
          // restrictions={this.props.restrictions}
          close={this.closeDrillDown}
          open={this.state.isOpen}
          // id={this.props.routeParams.id}
          // category={this.state.selectedCategory}
          // selectedFilters={this.state.selectedFilters}
          title={this.props.title || 'Vehicle'}
          showTable="Exemptions/Contributions"
          // fromNotification={this.state.fromNotification}
          // reportParam={this.props.reportParams}
        />
      </ContainerTop>
    );
  }
}

TableDetails.contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
};

// export default connect(
//   null,
//   null
// )(TableDetails);

export default TableDetails;



// WEBPACK FOOTER //
// ./src/features/insights/TableDetails.js